import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import AppLogo from '../components/AppLogo';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
    themes: {
      dark: {
        /**
         * green:  #0f2319
         * lime:   #00e100
         * mint:   #46dca5
         * cyan:   #00e6ff
         * blue:   #0091ff
         * purple: #9664ff
         * pink:   #ff32b4
         * red:    #ff4b41
         * orange: #ff7d00
         * yellow: #ffbe23
         * lemon:  #e6e623
         */
        primary: '#46dca5',
        secondary: '#00e6ff',
        accent: '#ff32b4',
        error: '#ff4b41',
        warning: '#ff7d00',
        success: '#46dca5',
        info: '#0091ff',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {
      logo: {
        component: AppLogo,
      },
    },
  },
});
